// start:ng42.barrel
export * from './report.component';
export * from './report-table.component';
// end:ng42.barrel
